import styled from '@emotion/styled'

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  min-height: var(--lumen-height-48);
  padding: var(--lumen-padding-8);
`
